import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CallButton from "../components/CallButton";
import { Heart, Squiggle, Sun } from "../components/Illustrations";
import { rooms } from "../data/rooms";

export default function RoomsPage() {
  useEffect(() => {
    document.title = "Οι Χώροι μας | Ορίζοντες Ανάπτυξης — Κέντρο Ειδικών Θεραπειών στο Περιστέρι";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Γνωρίστε τους χώρους του κέντρου μας στο Περιστέρι: Αίθουσα Αισθητηριακής Ολοκλήρωσης (SI), Αίθουσα Snoezelen, Αίθουσα Λογοθεραπείας, Πρώιμης Παρέμβασης και Χώρος Αναμονής.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", "https://orizontesanaptixis.gr/oi-choroi-mas");
    window.scrollTo(0, 0);
    return () => {
      document.title = "Ορίζοντες Ανάπτυξης | Κέντρο Ειδικών Θεραπειών στο Περιστέρι";
      if (canonical) canonical.setAttribute("href", "https://orizontesanaptixis.gr/");
      if (desc) desc.setAttribute("content", "Κέντρο Ειδικών Θεραπειών «Ορίζοντες Ανάπτυξης» στο Περιστέρι. Λογοθεραπεία, Εργοθεραπεία, Ψυχολογική Υποστήριξη, Πρώιμη Παρέμβαση & Συμβουλευτική Γονέων. Δωρεάν αξιολόγηση για κάθε παιδί.");
    };
  }, []);

  return (
    <div data-testid="rooms-page" className="min-h-screen bg-brand-bg">
      <Header />
      <main className="relative overflow-hidden pt-12 pb-20">
        <Sun className="absolute top-10 right-14 animate-spin-slow opacity-90 hidden md:block" size={80} />
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 font-body text-sm font-bold text-brand-textSoft hover:text-brand-primary transition-colors mb-8">
            <ArrowLeft size={16} /> Πίσω στην αρχική
          </Link>
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-text">
              Οι{" "}
              <span className="font-hand text-5xl sm:text-6xl text-brand-primary">χώροι μας</span>
              <Heart size={34} className="inline-block ml-2 animate-pulse-soft align-middle" color="#F4A899" />
            </h1>
            <Squiggle className="mx-auto my-5" width={170} color="#FBE4A8" />
            <p className="font-body text-base sm:text-lg text-brand-textSoft leading-relaxed">
              Κάθε γωνιά του κέντρου μας στο Περιστέρι είναι σχεδιασμένη με αγάπη,
              ώστε τα παιδιά να νιώθουν ασφάλεια και χαρά από την πρώτη στιγμή.
            </p>
          </div>

          {rooms.map((room, i) => (
            <section key={room.id} data-testid={`room-section-${room.id}`} className="mb-16">
              <div className={`inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 ${room.color} mb-3 ${i % 2 ? "rotate-1" : "-rotate-1"}`}>
                <Heart size={16} color="#F4A899" />
                <h2 className="font-heading font-bold text-lg sm:text-xl text-brand-text">{room.name}</h2>
              </div>
              <p className="font-body text-brand-textSoft leading-relaxed max-w-3xl mb-6">{room.desc}</p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                {room.photos.map((src, j) => (
                  <div key={j} className={`rounded-[1.5rem] overflow-hidden border-3 border-dashed ${room.color} bg-white ${j % 2 ? "rotate-1" : "-rotate-1"} hover:rotate-0 hover:scale-[1.02] transition-transform duration-500 shadow-[0_6px_0_-2px_rgba(91,79,70,0.15)]`}>
                    <img src={src} alt={`${room.name} — φωτογραφία ${j + 1}`} loading="lazy" decoding="async" className="w-full h-52 md:h-64 object-cover" />
                  </div>
                ))}
              </div>
            </section>
          ))}

          <div className="text-center mt-4">
            <a href="tel:+302105719375" className="inline-flex items-center gap-2 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold px-8 py-4 border-3 border-dashed border-white shadow-[0_5px_0_-2px_rgba(91,79,70,0.25)] hover:scale-105 transition-all duration-300">
              <Phone size={18} strokeWidth={2.4} /> Ελάτε να μας γνωρίσετε — 210 571 9375
            </a>
          </div>
        </div>
      </main>
      <Footer />
      <CallButton />
    </div>
  );
}
